
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {StarLevel} from '@/components';

export default {
name: 'hotel-base-info',
components: {
StarLevel,
Flexbox,
FlexboxItem,
},
props: {
hotelData: {
type: Object | null,
data(){
return null;
},
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/HotelBaseInfo.vue